<template>
  <div class="search-wrapper flex flex-row bg-white">
    <search-icn
      width="20px"
      height="20px"
      class="search-icon"
      :class="`${color}-icon`"
    ></search-icn>
    <button
      :class="[
        'border-t-4 border-l-4 border-b-0 h-10 search-keyword text-left',
        `border-${color}`,
        `${color}`,
      ]"
      @click.stop="focusChangedInput"
      >
      <span class="opacity-50">キーワードで検索</span>
    </button>
    <denomination-off-icn
      width="20px"
      height="20px"
      class="denomination-icon"
      fill-rule="evenodd"
      :class="`${color}-icon`"
    >
    </denomination-off-icn>
    <button
      :class="[
        'border-t-4 border-r-4 border-b-0 h-10 search-denomination',
        `border-${color}`,
        `${color}`,
      ]"
      @click.stop="focusChangedSelect"
    >
    <span class="opacity-50">会派選択</span>
    <chevron-icn
      width="20px"
      height="20px"
      class="chevron-icon top-0"
      :class="`${color}-icon`"
      ></chevron-icn>
  </button>
  </div>
</template>

<script>
import { useKeywordSearch } from '@/services/useKeywordSearch'
import { useInputSelectSearch } from '@/services/useInputSelectSearch'
import SearchIcn from '@/assets/icons/search.svg?inline'
import ChevronIcn from '@/assets/icons/chevron.svg?inline'
import DenominationOffIcn from '@/assets/icons/denomination-off.svg?inline'

export default {
  name: 'AppSearchInput',

  components: {
    SearchIcn,
    ChevronIcn,
    DenominationOffIcn,
  },

  props: {
    color: {
      type: String,
      default: '',
    },
  },

  setup() {
    const { isFocus, keyword, clearInput } = useKeywordSearch()
    const { isInput, isSelect } = useInputSelectSearch()

    const  focusChangedInput = () => {
      isInput.value = !isInput.value
    }
    const  focusChangedSelect = () => {
      isSelect.value = !isSelect.value
    }

    return { isFocus, keyword, clearInput, focusChangedInput, focusChangedSelect }
  },
}
</script>

<style lang="scss" scoped>
.search-wrapper {
  position: relative;

  .search-keyword {
    box-sizing: border-box;
    border-top-left-radius: 20px;
    padding-left: 42px !important;
    font-size: 18px;
    width: 282px;
  }

  .search-denomination{
    box-sizing: border-box;
    width: 206px;
    border-top-right-radius: 20px;
    padding-left: 42px !important;
    padding-right: 62px !important;
    font-size: 18px;
    cursor: pointer;
  }

  svg.search-icon {
    position: absolute;
    text-align: center;
    margin: 10px;
  }
  svg.denomination-icon {
    position: absolute;
    text-align: center;
    right: 144px;
    margin: 10px;
  }
  svg.chevron-icon {
    position: absolute;
    text-align: center;
    right: 0;
    margin: 15px 40px 5px 10px;
  }

  svg.clear-icon {
    position: absolute;
    right: 0px;
    margin: 10px;
  }
}
</style>